import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Form } from 'antd';
import { calculateCargoItemsTotalLdm } from 'shared/utils/ldm.ts';
import { CargoType } from 'types/cargo.ts';
import styles from './cargo-type-ldm-alert.module.scss';
import { PART_LOAD_MIN_LDM } from './constants';
import type { ICargoTypeLdmAlertProps } from './types';

export const CargoTypeLdmAlert: React.FC<ICargoTypeLdmAlertProps> = (props) => {
  const { form } = props;
  const { t } = useTranslation();

  const cargoType = Form.useWatch('type', form);
  const cargoItems = Form.useWatch('cargoItems', form);

  const totalLdm = calculateCargoItemsTotalLdm(cargoItems);

  const isLtlTypeMismatch = cargoType === CargoType.LTL && totalLdm >= PART_LOAD_MIN_LDM;

  const isPartLoadTypeMismatch = cargoType === CargoType.PART_LOAD && totalLdm > 0 && totalLdm < PART_LOAD_MIN_LDM;

  const mismatchTranslationKey = isLtlTypeMismatch
    ? 'ltl_type_mismatch'
    : isPartLoadTypeMismatch
    ? 'part_load_type_mismatch'
    : null;

  if (!mismatchTranslationKey) return null;

  return (
    <Alert
      className={styles.alert}
      message={<strong>{t(`cargo:${mismatchTranslationKey}`)}</strong>}
      description={t(`cargo:${mismatchTranslationKey}_description`, { totalLdm })}
      type='warning'
      showIcon
    />
  );
};
